import { Component, NgZone, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MaintenanceService } from 'src/app/services/maintenance-service/maintenance.service';
import { CommunicationService } from 'src/app/services/communication-service/communication.service';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { TurnsService } from 'src/app/services/turns-services/turns-service/turns.service';
import { Router } from '@angular/router';
import { APP_CONFIG } from 'src/app/config';
import { switchMap, map, tap, catchError } from 'rxjs/internal/operators';
import { ReactiveSocket } from 'sockets-lib';
import { OauthTokenData } from 'oauth-lib';
import { empty } from 'rxjs/internal/observable/empty';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  showRouterOutlet: boolean;
  appVersion: string;
  token: string;

  constructor(private userStorageService: UserStorageService,
              private maintenanceService: MaintenanceService,
              private turnsService: TurnsService,
              private securityService: SecurityService,
              private communicationService: CommunicationService,
              private router: Router,
              private ngZone: NgZone,
              private translate: TranslateService) {
    const userLang = navigator.language.replace('-', '_');
    this.appVersion = APP_CONFIG.appVersion;
    this.showRouterOutlet = false;
    if (this.userStorageService.getLang()) {
      this.translate.use(this.userStorageService.getLang());
    } else {
      this.userStorageService.setLang(userLang);
      this.translate.setDefaultLang(userLang);
      this.translate.use(userLang);
    }
  }

  ngOnInit() {
    this.setDeviceInfo().pipe(
      switchMap(setted => this.securityService.requestOAuthToken()),
      map((token: OauthTokenData) => this.userStorageService.setOAuthToken(token.access_token)),
      switchMap(saved => this.maintenanceService.isRegistered()),
      map(isRegistered => this.redirect(isRegistered))
    ).subscribe();
  }

  private setDeviceInfo() {
    return this.securityService.getFingerPrint().pipe(
      tap(res => this.userStorageService.setLang('es_ES')),
      tap(fingerprint => {
        this.userStorageService.setDeviceData(this.maintenanceService.fingerPrintDevice(fingerprint['components']));
        if (!this.userStorageService.getUDID() || (this.userStorageService.getUDID() === 'null')) {
          this.userStorageService.setUDID(fingerprint['udid']);
        }
      }),
      catchError(error => { console.dir(error); return empty; })
    );
  }

  private redirect(isRegistered) {
    if (isRegistered['isRegistered']) {
      this.showRouterOutlet = true;
      this.ngZone.run(() => {
        this.router.navigate(['/control']);
      });
    } else {
      this.token = isRegistered['token'];
      this.communicationService.connectToLimbo().pipe(
        switchMap(socket => socket.onConnect()),
        tap((registeredAsAnonymous: ReactiveSocket) => this.ngZone.run(() => {
          this.communicationService.updateAnonymous(registeredAsAnonymous).pipe(
            map(res => this.ngZone.run(() => {
              this.router.navigate(['/control']);
            })),
          ).subscribe();
          this.router.navigate(['/register', this.token]);
          this.showRouterOutlet = true;
        }))).subscribe();
    }
  }
}
